module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cyRCz"))).then(() => parcelRequire('2KbAe'));